//import axios from 'axios';
import api from '@/services/api';

export async function trackAppEvent(apiUrl, datos) {
  console.log('trackAppEvent called with:', datos);

  const params = {
    eventType: datos.type ? datos.type : null,
    teamName: datos.teamName ? datos.teamName : null,
    actionType: datos.description ? datos.description : null,
    language: datos.language ? datos.language : null,
    userAgent: datos.userAgent ? datos.userAgent : null,
  };


  try {
    await api.post(`${apiUrl}app-events`, {
      eventType: params.eventType,
      teamName: params.teamName,
      actionType: params.actionType,
      language: params.language,
      userAgent: params.userAgent,
    });
  } catch (error) {
    console.error('Error registrando evento:', error);
  }
}